import { RefObject, useEffect, useState } from 'react';

export const useHasPassedElementOnScroll = (ref: RefObject<HTMLElement | null>, deps: unknown[] = []): boolean => {
    const [hasPassed, setHasPassed] = useState<boolean>(false);

    useEffect((): () => void => {
        const checkScroll = (): void => {
            if (!ref.current) {
                return;
            }

            const menu = document.querySelector('.menu');

            if (!menu) {
                return;
            }

            const { height: menuHeight } = menu.getBoundingClientRect();

            const top = ref.current.getBoundingClientRect().top - menuHeight;

            const hasScrolledPast = top < 0;

            setHasPassed(hasScrolledPast);
        };

        checkScroll();

        window.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);

        return (): void => {
            window.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, [ref, ...deps]);

    return hasPassed;
};
